import { useMemo } from "react";
import { Button, Form, Icon, Icons, Menu } from "@ir/ui";
import { DATE_RANGE_LIST, FilterDateRange, FilterDateRangeSelectorProps } from "./interfaces";

const FilterDateRangeSelector: React.FC<FilterDateRangeSelectorProps> = ({
  fieldName,
  onChange,
  value,
  button,
  className,
}) => {
  const selectedValue = useMemo(() => {
    return value ? (DATE_RANGE_LIST.find(item => item.value === value)?.label ?? "Select") : "Select";
  }, [value]);

  const handleSelect = (key: string) => {
    if (!key) {
      return onChange?.(null);
    }
    onChange(DATE_RANGE_LIST.find(item => item.value === key)?.value as FilterDateRange);
  };

  return (
    <Menu items={DATE_RANGE_LIST} onSelect={handleSelect} placement="bottom end">
      <Form.Item name={fieldName} noStyle className="m-0">
        <Button
          variant="clear"
          color={button?.color || "grey"}
          size={button?.size || "small"}
          shape={button?.shape === null ? undefined : button?.shape ?? "pill"}
          style={{ fontSize: "12px" }}
          className={className}
        >
          {selectedValue} <Icon name={Icons.ChevronDown} size="small" color="grey" className="ms-2" />
        </Button>
      </Form.Item>
    </Menu>
  );
};

export default FilterDateRangeSelector;
